module.exports = __webpack_public_path__ + "static/img/detailjci.7a0b1b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailjci.jpg
// module id = Ew8o
// module chunks = 7